export default {
    // loading: 'monitor:operating:loading',
    // search: 'monitor:operating:search',
    // logs: 'monitor:operating:logs',
    // logsArea: 'monitor:operating:logsArea',

    loading: 'proxyExecuteData:loading',
    search: 'proxyExecuteData:search',
    logs: 'proxyExecuteData:logs',
    logsArea: 'proxyExecuteData:logsArea',

}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/proxyExecuteData/constant.js